
import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionDefinitionDto } from '@app/apiModules/permissionDefinitionDto';
import { Configuration } from '@app/common/configuration';
import { apiResponseFormat } from '@app/common/variables';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';



@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;
    authServerUrl = environment.API_APP_PATH;

    constructor(private readonly httpClient: HttpClient) {

    }
    public apiAppdefaultPermissionsGet(observe?: 'body', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<Array<PermissionDefinitionDto>>;
    public apiAppdefaultPermissionsGet(observe?: 'response', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpResponse<Array<PermissionDefinitionDto>>>;
    public apiAppdefaultPermissionsGet(observe?: 'events', reportProgress?: boolean, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<HttpEvent<Array<PermissionDefinitionDto>>>;
    public apiAppdefaultPermissionsGet(observe: any = 'body', reportProgress: boolean = false, options?: { httpHeaderAccept?: apiResponseFormat }): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<PermissionDefinitionDto>>(`${this.authServerUrl}/api/app/role/default-permissions`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}